import { AccountService, ModalService } from '@sm360/widget-commons-general';
import { SIGN_UP, LOGIN } from 'login/constants/modalNames.js';

/**
 * Get informations on account and open signup / login modals
 */
class LoginLightService {
    /**
     * Opens the login modal.
     */
    openLoginModal() {
        ModalService.get(LOGIN).open();
    }

    /**
     * Opens the signup modal.
     */
    openSignupModal(callbacks, properties = {}) {
        const signUpModal = ModalService.get(SIGN_UP);
        if (callbacks) {
            signUpModal.addCallbacks(callbacks);
        }
        signUpModal.open(properties);
    }

    /**
     * @param {function(err: ?Error, loggedAccount: [AccountRecord])} callback - Called with
     * a nullable Error and an optional AccountRecord object.
     */
    getLoggedAccount(callback) {
        AccountService.getLoggedAccount()
            .then((loggedAccount) => callback(null, loggedAccount))
            .catch((err) => callback(err));
    }

    /**
     * @return {boolean} isAuthenticated - True if the account is authenticated, False if not.
     */
    isAuthenticated() {
        return AccountService.isAuthenticated();
    }
}

export default new LoginLightService();
